export const HELP_URL = '/application-form/?label=specialists_page_empty';
